import React from "react";

import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/bootstrap.css";
import "./styles.css";

const DefaultPhoneInput = ({
  value = null,
  editCountryCode = true,
  placeholder = "+971 000 000 000",
  disabled = false,
  ...props
}) => {
  return (
    <PhoneInput
      country={"ae"}
      value={value}
      className={`default-phone-input ${disabled && "opacity-70"}`}
      countryCodeEditable={editCountryCode}
      placeholder={placeholder}
      disabled={disabled}
      {...props}
    />
  );
};

export default DefaultPhoneInput;
